/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from 'react'
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import { Table } from 'antd';
import { blogimg10, blogimg12, blogimg2, blogimg6, blogimg8, imagesend, pdficon, pdficon2, pdficon3, pdficon4, plusicon, refreshicon, searchnormal } from '../../components/imagepath';
import { FiChevronRight, FiSearch, FiX, FiRefreshCw } from "react-icons/fi";
import {onShowSizeChange,itemRender}from '../../components/Pagination'
import { BaseInput, BaseSelect, BaseButton } from '../../components/ui';
import reporteService from '../../services/reporteService';
import inmuebleService from '../../services/inmuebleService';
import moment from 'moment';
import { message } from 'antd';
import * as XLSX from 'xlsx';
import { FileExcelOutlined } from '@ant-design/icons';

const ReportePagos = () => {
    const navigate = useNavigate();
    const [inmuebles, setInmuebles] = useState([]);
    const [pagos, setPagos] = useState([]);
    const [estadisticas, setEstadisticas] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [filtros, setFiltros] = useState({
        fecha_inicio: '',
        fecha_fin: '',
        inmueble_id: '',
        estado: ''
    });

    const ESTADOS_PAGO = [
        { value: '', label: "Todos los estados" },
        { value: "pagado", label: "Pagado" },
        { value: "pendiente", label: "Pendiente" },
        { value: "vencido", label: "Vencido" },
        { value: "cancelado", label: "Cancelado" }
    ];

    // Cargar inmuebles al iniciar
    useEffect(() => {
        const cargarInmuebles = async () => {
            try {
                const data = await inmuebleService.obtenerInmuebles();
                const opcionesInmuebles = data.map(inmueble => ({
                    value: inmueble.id,
                    label: inmueble.nombre
                }));
                
                // Agregar opción "Todos los inmuebles"
                opcionesInmuebles.unshift({ value: '', label: "Todos los inmuebles" });
                
                setInmuebles(opcionesInmuebles);
            } catch (error) {
                console.error('Error al cargar inmuebles:', error);
            }
        };

        cargarInmuebles();
    }, []);

    // Función para generar el reporte
    const generarReporte = async () => {
        setLoading(true);
        try {
            // Añadir incluir_estadisticas=true para obtener estadísticas
            const filtrosConEstadisticas = { ...filtros, incluir_estadisticas: 'true' };
            const response = await reporteService.generarReportePagos(filtrosConEstadisticas);
            
            if (response.datos) {
                setPagos(response.datos);
                setEstadisticas(response.estadisticas);
                message.success('Datos actualizados correctamente');
            } else {
                setPagos(response);
                setEstadisticas(null);
                message.success('Datos actualizados correctamente');
            }
        } catch (error) {
            console.error('Error al generar reporte de pagos:', error);
            message.error('Error al actualizar los datos');
            setPagos([]);
            setEstadisticas(null);
        } finally {
            setLoading(false);
        }
    };

    // Generar reporte al cargar el componente
    useEffect(() => {
        generarReporte();
    }, []);

    const handleFiltroChange = (e) => {
        const { name, value } = e.target;
        setFiltros((prev) => ({ ...prev, [name]: value }));
    };

    const handleSearch = () => {
        generarReporte();
    };

    const handleLimpiarFiltros = () => {
        setFiltros({
            fecha_inicio: '',
            fecha_fin: '',
            inmueble_id: '',
            estado: ''
        });
        generarReporte();
    };

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    };

    const columns = [
        {
            title: "Nombre Inmueble",
            dataIndex: "nombre_inmueble",
            sorter: (a, b) => a.nombre_inmueble?.localeCompare(b.nombre_inmueble),
        },
        {
            title: "Espacio",
            dataIndex: "nombre_espacio",
            sorter: (a, b) => a.nombre_espacio?.localeCompare(b.nombre_espacio),
        },
        {
            title: "Inquilino",
            render: (_, record) => `${record.Nombres} ${record.Apellidos}`,
            sorter: (a, b) => `${a.Nombres} ${a.Apellidos}`.localeCompare(`${b.Nombres} ${b.Apellidos}`),
        },
        {
            title: "DNI",
            dataIndex: "DNI",
            sorter: (a, b) => a.DNI?.localeCompare(b.DNI),
        },
        {
            title: "Monto",
            dataIndex: "monto",
            sorter: (a, b) => parseFloat(a.monto || 0) - parseFloat(b.monto || 0),
            render: (monto) => `S/ ${parseFloat(monto).toFixed(2)}`
        },
        {
            title: "Método de Pago",
            dataIndex: "metodo_pago",
            sorter: (a, b) => a.metodo_pago?.localeCompare(b.metodo_pago),
            render: (text) => text?.charAt(0).toUpperCase() + text?.slice(1)
        },
        {
            title: "Tipo de Pago",
            dataIndex: "tipo_pago",
            sorter: (a, b) => a.tipo_pago?.localeCompare(b.tipo_pago),
            render: (text) => text?.charAt(0).toUpperCase() + text?.slice(1)
        },
        {
            title: "Fecha de Pago",
            dataIndex: "fecha_pago",
            sorter: (a, b) => new Date(a.fecha_pago) - new Date(b.fecha_pago),
            render: (fecha) => fecha ? new Date(fecha).toLocaleDateString("es-PE") : "N/A"
        },
        {
            title: "Estado",
            dataIndex: "estado",
            sorter: (a, b) => a.estado?.localeCompare(b.estado),
            render: (text) => {
                const estadoLowerCase = text?.toLowerCase();
                
                return (
                    <div>
                        {estadoLowerCase === "pagado" && (
                            <span className="custom-badge status-green">
                                Pagado
                            </span>
                        )}
                        {estadoLowerCase === "pendiente" && (
                            <span className="custom-badge status-pink">
                                Pendiente
                            </span>
                        )}
                        {estadoLowerCase === "vencido" && (
                            <span className="custom-badge status-red">
                                Vencido
                            </span>
                        )}
                        {estadoLowerCase === "cancelado" && (
                            <span className="custom-badge status-grey">
                                Cancelado
                            </span>
                        )}
                        {!["pagado", "pendiente", "vencido", "cancelado"].includes(estadoLowerCase) && (
                            <span className="custom-badge status-light">
                                {text || "Sin estado"}
                            </span>
                        )}
                    </div>
                );
            }
        },
      {/*  {
            title: "",
            dataIndex: "acciones",
            render: (_, record) => (
                <div className="text-end">
                    <div className="dropdown dropdown-action">
                        <Link
                            to="#"
                            className="action-icon dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <i className="fas fa-ellipsis-v" />
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end">
                            <Link className="dropdown-item" to={`/edit-payment/${record.id}`}>
                                <i className="far fa-edit me-2" />
                                Editar
                            </Link>
                            <Link className="dropdown-item" to="#" data-bs-toggle="modal" data-bs-target="#delete_patient">
                                <i className="fa fa-trash-alt m-r-5"></i> Eliminar
                            </Link>
                        </div>
                    </div>
                </div>
            ),
        },*/}
    ];

    // Usar useMemo para garantizar que la propiedad dataSource siempre reciba un array válido
    const datosTabla = useMemo(() => {
        if (!pagos || !Array.isArray(pagos)) {
            console.warn('pagos no es un array:', pagos);
            return [];
        }
        
        return pagos.map(item => ({
            key: item.id || `pago-${Math.random().toString(36).substring(2, 9)}`,
            ...item
        }));
    }, [pagos]);

    // Función para exportar a Excel
    const exportToExcel = () => {
        try {
            // Preparar los datos para Excel
            const dataForExcel = pagos.map(item => ({
                'Nombre Inmueble': item.nombre_inmueble || '',
                'Espacio': item.nombre_espacio || '',
                'Inquilino': `${item.Nombres || ''} ${item.Apellidos || ''}`,
                'DNI': item.DNI || '',
                'Monto': `S/ ${parseFloat(item.monto || 0).toFixed(2)}`,
                'Método de Pago': item.metodo_pago ? item.metodo_pago.charAt(0).toUpperCase() + item.metodo_pago.slice(1) : '',
                'Tipo de Pago': item.tipo_pago ? item.tipo_pago.charAt(0).toUpperCase() + item.tipo_pago.slice(1) : '',
                'Fecha de Pago': item.fecha_pago ? new Date(item.fecha_pago).toLocaleDateString("es-PE") : 'N/A',
                'Estado': item.estado ? item.estado.charAt(0).toUpperCase() + item.estado.slice(1) : ''
            }));

            // Agregar estadísticas si están disponibles
            if (estadisticas) {
                dataForExcel.push(
                    {},  // Fila vacía para separación
                    { 'Nombre Inmueble': 'RESUMEN ESTADÍSTICO' },
                    { 'Nombre Inmueble': 'Total Registros', 'Monto': estadisticas.total_registros },
                    { 'Nombre Inmueble': 'Monto Total', 'Monto': `S/ ${estadisticas.total_monto.toFixed(2)}` },
                    { 'Nombre Inmueble': 'Pagos Cancelados', 'Monto': estadisticas.pagos_completados },
                    { 'Nombre Inmueble': 'Pagos Pendientes', 'Monto': estadisticas.pagos_pendientes }
                );
            }

            // Crear libro de Excel
            const ws = XLSX.utils.json_to_sheet(dataForExcel);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Reporte de Pagos");

            // Generar nombre del archivo con fecha
            const fecha = moment().format('YYYY-MM-DD');
            const fileName = `Reporte_Pagos_${fecha}.xlsx`;

            // Guardar archivo
            XLSX.writeFile(wb, fileName);
            message.success('Reporte exportado exitosamente');
        } catch (error) {
            console.error('Error al exportar a Excel:', error);
            message.error('Error al exportar el reporte');
        }
    };

    return (
        <>
            <Header />
            <Sidebar id='menu-item6' id1='menu-items6' activeClassName='reporte-pagos' />
            <>
                <div>
                    <div className="page-wrapper">
                        <div className="content">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                               <Link to="#">Reporte
                                                </Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <i className="feather-chevron-right" >
                                                    <FiChevronRight icon="chevron-right"/>
                                                    </i>

                                                </li>
                                            <li className="breadcrumb-item active">Pagos
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card card-table show-entire">
                                        <div className="card-body">
                                            {/* Table Header */}
                                            <div className="page-table-header mb-2">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <div className="doctor-table-blk">
                                                            <h3>Lista de Pagos</h3>
                                                            <div className="doctor-search-blk">
                                                                
                                                                <div className="add-group">
                                                                    <BaseButton
                                                                      type="button"
                                                                      variant="primary"
                                                                      className="ms-2 add-pluss"
                                                                      icon={<img src={plusicon} alt="Nuevo pago" />}
                                                                      onClick={() => navigate('/contabilidad-pagos')}
                                                                      title="Ir a pagos"
                                                                    />
                                                                    <BaseButton
                                                                      type="button"
                                                                      variant="primary"
                                                                      className="ms-2 doctor-refresh"
                                                                      loading={loading}
                                                                      icon={<FiRefreshCw />}
                                                                      onClick={generarReporte}
                                                                      title="Actualizar reporte"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-auto text-end float-end ms-auto download-grp">
                                                        <BaseButton
                                                            type="button"
                                                            variant="success"
                                                            className="ms-2"
                                                            icon={<FileExcelOutlined />}
                                                            onClick={exportToExcel}
                                                            title="Exportar a Excel"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Table Header */}
                                            <div className="staff-search-table">
                                                <form>
                                                    <div className="row g-3">
                                                        <div className="col-12 col-md-6 col-xl-3">
                                                            <BaseInput
                                                                label="Desde"
                                                                name="fecha_inicio"
                                                                type="date"
                                                                value={filtros.fecha_inicio}
                                                                onChange={handleFiltroChange}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-3">
                                                            <BaseInput
                                                                label="Hasta"
                                                                name="fecha_fin"
                                                                type="date"
                                                                min={filtros.fecha_inicio || undefined}
                                                                value={filtros.fecha_fin}
                                                                onChange={handleFiltroChange}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-3">
                                                            <BaseSelect
                                                                label="Inmueble"
                                                                name="inmueble_id"
                                                                isSearchable
                                                                value={filtros.inmueble_id}
                                                                onChange={handleFiltroChange}
                                                                placeholder="Seleccionar inmueble"
                                                                options={inmuebles}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-3">
                                                            <BaseSelect
                                                                label="Estado de Pago"
                                                                name="estado"
                                                                value={filtros.estado}
                                                                onChange={handleFiltroChange}
                                                                placeholder="Seleccionar estado"
                                                                options={ESTADOS_PAGO}
                                                            />
                                                        </div>
                                                        <div className="col-12 col-md-6 col-xl-3 ms-auto">
                                                            <div className="d-flex gap-2 justify-content-end">
                                                                <BaseButton
                                                                    type="button"
                                                                    variant="primary"
                                                                    icon={<FiSearch />}
                                                                    onClick={handleSearch}
                                                                    loading={loading}
                                                                >
                                                                    Buscar
                                                                </BaseButton>
                                                                <BaseButton
                                                                    type="button"
                                                                    variant="secondary"
                                                                    icon={<FiX />}
                                                                    onClick={handleLimpiarFiltros}
                                                                >
                                                                    Limpiar
                                                                </BaseButton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            
                                            {/* Estadísticas */}
                                            {estadisticas && (
                                                <div className="row mb-4">
                                                    <div className="col-md-3">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <h5 className="card-title">Total Registros</h5>
                                                                <p className="card-text h4">{estadisticas.total_registros}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <h5 className="card-title">Monto Total</h5>
                                                                <p className="card-text h4">S/ {estadisticas.total_monto.toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <h5 className="card-title">Pagos Cancelados</h5>
                                                                <p className="card-text h4">{estadisticas.pagos_completados}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="card bg-light">
                                                            <div className="card-body">
                                                                <h5 className="card-title">Pagos Pendientes</h5>
                                                                <p className="card-text h4">{estadisticas.pagos_pendientes}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            <div className="table-responsive">
                                                <Table
                                                    pagination={{
                                                        total: datosTabla.length,
                                                        showTotal: (total, range) => `Mostrando ${range[0]} a ${range[1]} de ${total} entradas`,
                                                    }}
                                                    style={{ overflowX: 'auto' }}
                                                    columns={columns}
                                                    dataSource={datosTabla}
                                                    rowKey={record => record.key}
                                                    rowSelection={rowSelection}
                                                    loading={loading}
                                                    locale={{ emptyText: 'No hay datos disponibles' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="notification-box">
                            <div className="msg-sidebar notifications msg-noti">
                                <div className="topnav-dropdown-header">
                                    <span>Messages</span>
                                </div>
                                <div className="drop-scroll msg-list-scroll" id="msg_list">
                                    <ul className="list-box">
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">R</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">Richard Miles
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item new-message">
                                                    <div className="list-left">
                                                        <span className="avatar">J</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">John Doe</span>
                                                        <span className="message-time">1 Aug</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">T</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">
                                                            Tarah Shropshire
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">M</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">Mike Litorus</span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">C</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">
                                                            Catherine Manseau
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">D</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">
                                                            Domenic Houston
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">B</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">
                                                            Buster Wigton
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">R</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">
                                                            Rolland Webber
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">C</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">
                                                            Claire Mapes
                                                        </span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">M</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">Melita Faucher</span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">J</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">Jeffery Lalor</span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">L</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">Loren Gatlin</span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                           <Link to="#">
                                                <div className="list-item">
                                                    <div className="list-left">
                                                        <span className="avatar">T</span>
                                                    </div>
                                                    <div className="list-body">
                                                        <span className="message-author">Tarah Shropshire</span>
                                                        <span className="message-time">12:28 AM</span>
                                                        <div className="clearfix" />
                                                        <span className="message-content">Lorem ipsum dolor sit amet, consectetur adipiscing</span>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                                <div className="topnav-dropdown-footer">
                                   <Link to="#">See all messages</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>
        </>
    )
}

export default ReportePagos;
